/**
 * `<LabelMono>` — uppercase tracked label in mono.
 *
 * Used as a section separator where a heading would be too heavy: above
 * filter groups, dashboard widget titles, metadata sidecar sections. Per
 * the design system: 10.5px, letter-spacing 0.14em, uppercase, --fg-4.
 */

import type { HTMLAttributes, ReactNode } from 'react';

interface LabelMonoProps extends HTMLAttributes<HTMLDivElement> {
  children: ReactNode;
}

export function LabelMono({ className = '', children, ...rest }: LabelMonoProps): JSX.Element {
  return (
    <div className={`label-mono ${className}`.trim()} {...rest}>
      {children}
    </div>
  );
}
